import { Box } from '@material-ui/core'
import clsx from 'clsx'
import Image from '@v4/components/common/Image'
import EditableHTML from '@v4/components/common/EditableHTML'
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import ItemBorder from '@v4/components/common/ItemBorder'
import EditableContainer from '@v4/components/common/EditableContainer'
import { useItem } from './Item.hooks'

const Item = props => {
	const [
		{ classes, withImage, image, text, textConfig, itemKey, group, textEditable, textKey },
		{ handleImageClick, handleTextClick, handleClick, handleTextChange },
	] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group}>
			<Box className={clsx(classes.content, 'category2-item-content')} onClick={handleClick}>
				{withImage && (
					<Image
						className={clsx(classes.image, 'category2-item-image')}
						metaData={image}
						onClick={handleImageClick}
					/>
				)}
				<EditableContainer
					visible={!!text}
					fieldConfig={textConfig}
					onAdd={handleTextChange}
					editable={textEditable}
				>
					<EditableHTML
						key={textKey}
						className="category2-item-text-block"
						html={text}
						onClick={handleTextClick}
						editable={textEditable}
						onChange={handleTextChange}
					/>
				</EditableContainer>
			</Box>
		</ItemBorder>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
}
export default memo(Item)
